"use strict";

import angular from "angular";
import {
    customerUsers,
    nucontersUsers
} from "../../../../utils/users-roles/users-roles";
angular
    .module("nucont.accounting.overview")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.overview.portfolio.companies", {
            url: "/empresas",
            params: {
                toastPGDAS: { value: null, dynamic: true },
                from: { value: null, dynamic: true }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3"
                }
            },
            views: {
                "submodules@nucont.accounting.overview.portfolio": {
                    component: "accountingCompaniesViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.portfolio.groups", {
            url: "/grupos",
            params: {},
            data: {
                rolesGuard: [...nucontersUsers, ...customerUsers],
                layoutConfig: {
                    model: "LayoutConfigModel3"
                }
            },
            views: {
                "submodules@nucont.accounting.overview.portfolio": {
                    component: "accountingGroupsViewComponent"
                }
            }
        });
}
